
/***
 * GERAL
 ***/
$(function() {
    $('.animsition').animsition().one('animsition.inStart',function(){
        App.SetToggle();
        App.SetGaleria();
        App.SetBanner();
        App.SetCarouselMobile();
        App.SetHeaderFixed(129);
        App.SetValidate();
        App.SetMaskInput();
        App.SetInputError();
        App.SetFormSuccess();
        App.SetAnimatescroll(150);
        App.SetWow(200);

        $('html').addClass('loaded');

        // Open videos popup
        $('.open-video').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });

        // Popup imagens
        $('.gallery').each(function (index, el) {
            $(el).magnificPopup({
                delegate: 'a',
                type: 'image',
                gallery: {
                    enabled: true
                }
            });
        });

        // Pagination
        // var countPag = 2;
        // var total    = $('.Tratamento .imagens .imagem').length;
        // $('.Tratamento .imagens .imagem:gt(1)').hide();

        // if (countPag >= total) {
        //     $('.Tratamento .Button').hide();
        // }

        // $('.Tratamento .Button').click(function(event) {
        //     event.preventDefault();

        //     countPag = countPag + 2; 

        //     if (countPag >= total) {
        //         $(this).hide();
        //     }

        //     $('.Tratamento .imagens .imagem:lt(' + countPag +')').show();
        // });

        // Cookies
        if (localStorage.hasOwnProperty('verify_cookies')) {
            $('.Cookies').addClass('_hide');
        }

        $('.Cookies .Button').click(function(event) {
            event.preventDefault();
            localStorage.setItem('verify_cookies', true);
            $('.Cookies').addClass('_hide');
        });

        // Select categorias mobile
        $(document).on('change', '.select-categorias', function(event) {
            if ($(this).val()) {
                window.location.href = site_url + '/categorias/' + $(this).val();
            }
        });
    });
});


